// АНИМ.1: автоматический incoming-эффект для legacy useNavigate-вызовов.
//
// Большая часть экранов в проекте использует обычный useNavigate (~50+
// мест). Поэтапно переходить на useScreenTransition можно, но дольше.
// Этот listener даёт минимальный эффект "из коробки": при смене
// location.pathname без активного перехода — запускается только
// incoming-фаза. Outgoing нет (старый экран уже размонтирован роутером),
// но игрок всё равно видит fade-in на новом экране.
//
// Если переход был запущен через useScreenTransition (phase !== 'idle'
// в момент смены location) — этот listener не вмешивается.

import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTransitionStore } from './transitionStore';
import { useAnimationsEnabled } from '../hooks/useAnimationsEnabled';
import { VARIANT_TIMINGS } from './types';
import { routeVariant } from './routeVariants';

export function AutoIncomingListener() {
  const location = useLocation();
  const enabled = useAnimationsEnabled();
  const phase = useTransitionStore((s) => s.phase);
  const setPhase = useTransitionStore((s) => s.set);
  const prevPathRef = React.useRef(location.pathname);
  // Используем ref на phase чтобы не пересоздавать effect при каждом
  // setPhase (фаза меняется внутри самого effect).
  const phaseRef = React.useRef(phase);
  React.useEffect(() => { phaseRef.current = phase; }, [phase]);

  React.useEffect(() => {
    const prev = prevPathRef.current;
    const next = location.pathname;
    prevPathRef.current = next;
    if (prev === next) return;
    if (!enabled) return;
    // Если уже идёт ручной переход через useScreenTransition — он сам
    // разрулит incoming. Не дублируем.
    if (phaseRef.current !== 'idle') return;

    const variant = routeVariant(next);
    const ms = VARIANT_TIMINGS[variant].in;
    setPhase('incoming', variant);
    const t1 = setTimeout(() => setPhase('idle', variant), ms);
    return () => clearTimeout(t1);
  }, [location.pathname, enabled, setPhase]);

  return null;
}
